var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeFlag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_397_162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "germany",
    d: "M-1.39844 29.4002C2.01379 38.5965 10.8658 45.1503 21.2495 45.1503C31.6331 45.1503 40.4851 38.5965 43.8973 29.4002L21.2495 27.3003L-1.39844 29.4002Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "germany_2",
    d: "M21.2495 -3.1499C10.8658 -3.1499 2.01379 3.4038 -1.39844 12.6001L21.2495 14.7001L43.8973 12.6C40.4851 3.4038 31.6331 -3.1499 21.2495 -3.1499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "germany_3",
    d: "M-1.39828 12.6001C-2.369 15.2163 -2.90039 18.046 -2.90039 21.0001C-2.90039 23.9541 -2.369 26.7838 -1.39828 29.4H43.8976C44.8683 26.7838 45.3996 23.9541 45.3996 21.0001C45.3996 18.046 44.8683 15.2163 43.8975 12.6001H-1.39828Z",
    fill: "#D80027"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_397_162"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.90039 21.0001C-2.90039 7.66242 7.91193 -3.1499 21.2496 -3.1499C34.5873 -3.1499 45.3996 7.66242 45.3996 21.0001C45.3996 34.3378 34.5873 45.1501 21.2496 45.1501C7.91193 45.1501 -2.90039 34.3378 -2.90039 21.0001Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeFlag);
export default __webpack_public_path__ + "static/media/de-flag.e16ea4856426e48e96b9055ab64cc653.svg";
export { ForwardRef as ReactComponent };